import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ViewChild } from "@angular/core";
import { EditableGridComponent } from "projects/sepidz-web-framework-data-grid/src/lib/editable-grid/editable-grid.component";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { form_control } from "projects/sepidz-web-framework/src/lib/models";
import { Dictionary } from "projects/sepidz-web-framework/src/lib/models/dictionary";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";
import { GridFilter, LookupService, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { takeUntil } from "rxjs/operators";
import { DebtorCreditorNoticesKind } from "../../models/credit-function-kind.enums";
import { DebtorCreditorNoticesHeader } from "../../models/debtor-creditor-notices-header.model";

@Component({
  selector: "debtor-creditor-notices-header-form",
  templateUrl: "./debtor-creditor-notices-header-form.component.html",
  styleUrls: ["./debtor-creditor-notices-header-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DebtorCreditorNoticesHeaderFormComponent extends BaseFormComponent<DebtorCreditorNoticesHeader> {
  erroremessage: string;
  DefaultValues: Dictionary = [];
  isCreatingAccVoucher: boolean = false;
  DebtorCreditorNoticesDetailColumns: form_control[] = [];
  @ViewChild("detail") public detail: EditableGridComponent;
  get currentFiscalYear() {
    return this.accountService.authService.currentFiscalYear;
  }
  constructor(
    private lookupservice: LookupService,
    selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    private splashFormService: SplashFormService
  ) {
    super(selectorService, cd);
  }
  async ngOnInit() {
    this.DefaultValues["DebtorCreditorNoticesHeaderId"] = 0;
    this.selectorService.setDisabledValue("GoodsId", true);
    this.apiName = "DebtorCreditorNoticesHeader";
    this.label = "اعلامیه بدهکار بستانکار";
    this.defaultCoumnNumber = 6;
    super.ngOnInit();
  }
  setdefault() {
    if (!this.model.DebtorCreditorNoticesDetailList) this.model.DebtorCreditorNoticesDetailList = [];
    if (!this.model.BranchId) this.model.BranchId = this.accountService.authService.currentBranchId;
    if (!this.model.DebtorCreditorKindId) {
      this.lookupservice
        .getLookupbyCode("SELL", "DebtorCreditorNoticesKind", DebtorCreditorNoticesKind.Normal)
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe((x) => {
          if (x) {
            this.model.DebtorCreditorKindId = x.Id;
            this.model.DebtorCreditorKindCode = x.Code;
            this.model.DebtorCreditorKindTitle = x.Title;
            this.setValue("DebtorCreditorKindId", this.model.DebtorCreditorKindId);
            this.setValue("DebtorCreditorKindCode", this.model.DebtorCreditorKindCode);
            this.setValue("DebtorCreditorKindTitle", this.model.DebtorCreditorKindTitle);
          }
        });
    }
    if (!this.model.FiscalYearId && this.currentFiscalYear) {
      this.model.FiscalYearId = this.currentFiscalYear.Id;
      this.model.Year = this.currentFiscalYear.Year;
    } else if (!this.model.FiscalYearId) {
      this.accountService.authService.currentFiscalYearobsr.pipe(takeUntil(this.ngUnsubscribe)).subscribe((x) => {
        if (x) {
          this.model.FiscalYearId = x.Id;
          this.model.Year = x.Year;
          this.setValue("FiscalYearId", x.Id);
          this.setValue("Year", x.Year);
        }
      });
    }
    this.setColumnAttribute();
  }
  setColumnAttribute() {
    this.orignalColumns.forEach((x) => {
      if (x.name === "DebtorCreditorDate" || x.name === "Comment") x.disabled = this.model.AccVoucherHeaderId != undefined;
    });
    this.columns.forEach((x) => {
      if (x.name === "DebtorCreditorDate" || x.name === "Comment") x.disabled = this.model.AccVoucherHeaderId != undefined;
    });
    this.DebtorCreditorNoticesDetailColumns = this.getDetailControlModels("DebtorCreditorNoticesDetailList");
  }
  setMaxCode() {
    this.httpCommonService
      .getMaxCode(this.apiName)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((data) => {
        if (!this.model) this.model = <DebtorCreditorNoticesHeader>{};
        if (data) {
          this.model["Code"] = data as number;
        }
        this.setFormGroup(this.model);
      });
  }
  async accountAccVoucher(create: boolean = true) {
    let gridFilter: GridFilter[] = [];
    let DebtorCreditorNoticesHeaderIds: number[] = [];
    DebtorCreditorNoticesHeaderIds.push(this.model.Id);
    let filter: GridFilter = {
      Type: "F",
      Filed: "DebtorCreditorNoticesHeaderIds",
      Value: DebtorCreditorNoticesHeaderIds,
      Logic: "and",
      Operator: "eq",
      Skip: 0,
      Take: 0,
    };
    gridFilter.push(filter);
    if (this.model.AccVoucherHeaderId !== undefined && this.model.AccVoucherHeaderId > 0 && !create) {
      await this.deleteAccVoucher();
    }
    if (create) await this.createAccVoucher(gridFilter);
  }

  async createAccVoucher(gridFilter: GridFilter[]) {
    if (this.isCreatingAccVoucher === true) return;
    this.isCreatingAccVoucher = true;
    this.splashFormService.openDialog("", "در حال صدور سند حسابداری");
    await this.httpCommonService
      .create(this.apiName + "/CreateAccVoucher", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog("سند با موفقیت صادر شد.", "");
          await this.ngOnInit();
          this.isCreatingAccVoucher = false;
        },
        async (error) => {
          await this.ngOnInit();
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در صدور اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
          this.isCreatingAccVoucher = false;
        }
      );
  }
  async deleteAccVoucher() {
    this.splashFormService.openDialog("", "در حال حذف سند حسابداری");
    await this.httpCommonService
      .create(this.apiName.split("/")[0] + "/DeleteAccVoucher", this.model)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(
        async (x) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog("سند با موفقیت حذف شد.", "");
          this.isCloseable();
          await this.ngOnInit();
          this.cd.markForCheck();
        },
        (error) => {
          this.splashFormService.closeLoading();
          this.sts.showDialog(`خطا در حذف اسناد${Utilities.getHttpResponseMessage(error)}`, "خطا");
        }
      );
  }
  beforupdate() {
    this.setValue(
      "DebtorCreditorNoticesDetailList",
      this.model.DebtorCreditorNoticesDetailList.filter((x) => x.State !== RowState.Detached)
    );
    if (!this.model.DebtorCreditorNoticesDetailList || this.model.DebtorCreditorNoticesDetailList.length <= 0)
      this.model.DebtorCreditorNoticesDetailList = undefined;
    else
      this.setValue(
        "DebtorCreditorNoticesDetailList",
        this.model.DebtorCreditorNoticesDetailList.filter((x) => x.State !== RowState.Detached)
      );
  }
  isCloseable() {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    this.currentrow = this.model;
    return false;
  }
}
